<template>
  <Dialog v-slot="{ ok }" v-model="show" title="" nofocus :forceOption="forceOption" @ok="onOk" @cancel="onCancel">
    <p>{{ msg }}</p>
    <input ref="input" v-model="text" type="text" @keydown.enter="ok(true)" />
  </Dialog>
</template>

<script lang="ts" setup>
import Dialog from './Dialog.vue';
import { showPromptDialog, dialogMessage, dialogOk, forceOption } from '../utils';
import { ref, watch } from 'vue';

const show = showPromptDialog;
const msg = dialogMessage;
const text = ref('');
const input = ref<HTMLInputElement | null>(null);

const onOk = () => {
  dialogOk(text.value);
  text.value = '';
};

const onCancel = () => {
  text.value = '';
};

watch(
  show,
  (val) => {
    if (val) {
      input.value?.focus();
    }
  },
  { flush: 'post' },
);
</script>
